import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PoliciesGuard from 'components/PoliciesGuard';
import RootACLProvider from 'components/RootACLProvider';
import RootContainer from 'components/RootContainer';
import { SnackbarProviderStyled } from 'components/styled/SnackbarProviderStyled';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Routing } from 'routing';
import { initClarity } from 'utils/clarity';
import { Inactivity } from './context/InactivityContext';
import './i18n/config';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

if (['production'].includes(process.env.NODE_ENV)) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const CLARITY_PROJECT_ID = 'pijrbdqxci';

if (process.env.NODE_ENV !== 'development' && CLARITY_PROJECT_ID) {
  initClarity(CLARITY_PROJECT_ID);
}

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <CookiesProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <SnackbarProviderStyled maxSnack={10}>
            <PoliciesGuard>
              <RootContainer>
                <RootACLProvider>
                  <Inactivity>
                    <Routing />
                  </Inactivity>
                </RootACLProvider>
              </RootContainer>
            </PoliciesGuard>
          </SnackbarProviderStyled>
        </QueryClientProvider>
      </LocalizationProvider>
    </CookiesProvider>
  </ThemeProvider>
);

reportWebVitals();
